module.exports = __webpack_public_path__ + "9a6c488337c55eacd717e839a32f75b8.jpg";